// @flow

import { EnrolmentType } from "../../global/types/FaceType";
import { EnrolmentInputModel } from "./InputModels";
export type UserType = {
  auth?: boolean,
  email?: string,
  email_verified?: boolean,
  facebase_name?: string,
  facebase_uuid?: string,
  fetchingAuth?: boolean,
  first_name?: string,
  last_name?: string,
  full_name?: string,
  groups?: Array<string>,
  logins?: Array<Array<*>>
};

export type PersonType = {
  uid: string,
  name: string,
  tags: string[],
  enrolments: EnrolmentType[],
  details: *
};
